import { CreateFileParams, FileParams } from "./fileTypes";
import { FusaReply } from "./replyTypes";

export enum CUSTOM_FIELD_TYPES {
  String = 'string',
  MultilineText = 'multilineText',
  Integer = 'integer',
  Float = 'float',
  Boolean = 'boolean',
  Object = 'object',
  File = 'file',
  Validation = 'validation',
};

export const TEXT_CUSTOM_FIELD_TYPES = [CUSTOM_FIELD_TYPES.String, CUSTOM_FIELD_TYPES.MultilineText, CUSTOM_FIELD_TYPES.Integer, CUSTOM_FIELD_TYPES.Float, CUSTOM_FIELD_TYPES.Boolean];

export const NUMBER_CUSTOM_FIELD_TYPES = [CUSTOM_FIELD_TYPES.Integer, CUSTOM_FIELD_TYPES.Float];

export enum CUSTOM_FIELD_SUBJECT_TYPES {
  PARAMETER = 'parameter',
  REPORT_ITEM = 'report_item',
  EQUIPMENT = 'equipment',
}

export interface CustomFieldCreateParams {
  subjectId: string,
  subjectType: CUSTOM_FIELD_SUBJECT_TYPES,
  fieldType: CUSTOM_FIELD_TYPES,
  defaultValue?: string | number | boolean,
  customValue?: string | number | boolean,
  isSelected?: boolean,
  position?: number;
  objectInstance?: Pick<ObjectInstanceCreateData, 'objectShapeId' | 'title'>
  file?: Omit<CreateFileParams, 'subjectId' | 'subjectType'>,
  sourceId?: string;
  isRequired?: boolean;
  isCustomChoice?: boolean;
  title?: string;
}

export interface CustomFieldParams extends CustomFieldCreateParams {
  id: string,
  createdAt?: string | Date,
  updatedAt?: string | Date,
  subjectId: string,
  subjectType: CUSTOM_FIELD_SUBJECT_TYPES,
  isSelected?: boolean,
  position?: number;
  objectInstance?: ObjectInstanceData;
  file?: FileParams,
  isRequired?: boolean,
}

export interface CreateCustomFieldReply extends FusaReply {
  customField?: CustomFieldParams;
}

export interface ObjectInstanceCreateData {
  customFieldId: string;
  objectShapeId?: string;
  title?: string;
}

export interface ObjectInstanceData extends ObjectInstanceCreateData {
  id: string;
  createdAt?: string | Date;
  updatedAt?: string | Date;
  objectShapeId: string;
  properties: ObjectPropertyData[];
  title: string;
}

export interface ObjectShapeData {
  id: string;
  createdAt?: string;
  updatedAt?: string;
}

export enum ObjectKeyVisibility {
  EDITABLE = 'editable',
  HIDDEN = 'hidden',
  VIEW_ONLY = 'view_only',
}

export type ObjectKeyCreateData = {
  name: string | null;
  type: CUSTOM_FIELD_TYPES;
  objectShapeId: string;
  inputType?: string;
  visibility: ObjectKeyVisibility;
  title?: string;
  description?: string;
};

export interface KeyData {
  key: string;
  keyId: string;
  type: CUSTOM_FIELD_TYPES;
  inputType?: string;
  visibility: ObjectKeyVisibility;
  title: string;
  description: string;
}

export interface ObjectPropertyData extends KeyData {
  valueId: string;
  value: string;
  file?: FileParams;
}

export interface ObjectKeyData extends ObjectKeyCreateData {
  id: string;
  createdAt?: Date | string;
  updatedAt?: Date | string;
}

export interface ObjectKeyChoiceData {
  id: string;
  createdAt?: Date | string;
  updatedAt?: Date | string;
  objectKeyId: string;
  value: string;
  position: number;
}

export type ObjectKeyChoiceCreateData = Omit<ObjectKeyChoiceData, 'id' | 'createdAt' | 'updatedAt'>;

export interface ObjectValueData {
  id: string;
  createdAt?: Date | string;
  updatedAt?: Date | string;
  value?: string;
  objectKeyId: string;
  objectInstanceId: string;
}

export type ObjectValueCreateData = Omit<ObjectValueData, 'id' | 'createdAt' | 'updatedAt'> & { 
  file?: Omit<CreateFileParams, 'subjectId' | 'subjectType'> 
};

export type ObjectValueBulkCreateData = Omit<ObjectValueData, 'createdAt' | 'updatedAt'> & { 
  file?: FileParams 
};

